/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { Actionable, Text, View } from '@az/starc-ui';
import { Icon } from '@az/starc-ui';
import { ChevronDown, Chat } from '@az/starc-ui-icons';
import { useState } from 'react';
import { useTimeAgo } from '../../../hooks/useTimeAgo';
import { useLabels } from '@/hooks/useLabels';

type ResponseProps = {
  date: string;
  team: string;
  text: string;
};

const labelMap = {
  responseFrom: 'label_reviews_responseFrom',
  close: 'label_Homepage_content_Close',
  open: 'label_Footer_modal_Open',
};

export const Response = ({ date, team, text }: ResponseProps) => {
  const labels = useLabels(labelMap);

  const [open, setOpen] = useState(false);

  const { getPostedDate } = useTimeAgo();

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <View>
      <Actionable
        className={styles.responseHeader}
        onClick={handleClick}
        attributes={{ 'aria-expanded': open }}
      >
        <View className={styles.leftSide}>
          <Icon svg={Chat} size={7} />
          <Text variant="main-body" weight="bold">
            {`${labels.responseFrom} ${team}:`}
          </Text>
        </View>
        <View className={open && styles.rotateChevron}>
          <Icon svg={ChevronDown} size={6} />
        </View>
      </Actionable>
      {open ? (
        <View className={styles.responseContent}>
          <Text variant="main-body" className={styles.responseText}>
            {text}
          </Text>
          <Text variant="small-body" align="end" className={styles.responseDate}>
            {getPostedDate(date)}
          </Text>
        </View>
      ) : null}
    </View>
  );
};
